import React from 'react';
import ReactDOM from 'react-dom';
import {unregister as unregisterServiceWorker} from './registerServiceWorker';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
unregisterServiceWorker()
